module.exports = __webpack_public_path__ + "static/media/img001.4e8bbf39.jpg";